import t, { css as n } from "styled-components";
import e from "../../utils/colors.js";
const r = n`
  letter-spacing: -0.3px;
  font-weight: ${(s) => s.fontWeight || "normal"};
  color: ${e.blueGrey};
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
`, o = t.div`
  ${r};
`, a = t(o).attrs({
  as: "h1"
})`
  font-size: 28px;
`, i = t(o).attrs({
  as: "h2"
})`
  font-size: 22px;
`, c = t(o).attrs({
  as: "h3"
})`
  font-size: 18px;
`, p = {
  H1: a,
  H2: i,
  H3: c
};
export {
  o as BaseComponent,
  r as HeaderStyles,
  p as default
};
